var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 68H12.75C5.70775 68 0 62.2922 0 55.25V12.75C0 5.70775 5.70775 0 12.75 0H55.25C62.2922 0 68 5.70775 68 12.75V55.25C68 62.2922 62.2922 68 55.25 68Z",
    fill: "url(#paint0_linear_1223_9072)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1223_9072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.02 13.944H44.2252V11.7989C44.2252 11.1049 43.4681 10.7895 42.7741 10.7895H39.0519C38.1686 8.2659 35.9604 7.00409 33.4368 7.00409C30.941 6.91026 28.6708 8.44063 27.8218 10.7895H24.1625C23.4685 10.7895 22.7745 11.1049 22.7745 11.7989V13.944H17.9796C15.1381 13.9743 12.8135 16.2158 12.6799 19.0543V55.205C12.6799 57.981 15.2036 59.9999 17.9796 59.9999H49.02C51.796 59.9999 54.3197 57.981 54.3197 55.205V19.0544C54.1861 16.2158 51.8615 13.9743 49.02 13.944ZM25.298 13.3131H28.768C29.3738 13.2392 29.8603 12.7784 29.9668 12.1775C30.3404 10.5504 31.7679 9.38243 33.4368 9.33848C35.0902 9.38859 36.4962 10.5602 36.8437 12.1775C36.9568 12.7992 37.4755 13.2659 38.1055 13.3131H41.7017V18.3604H25.298V13.3131ZM51.796 55.2051C51.796 56.5931 50.408 57.4764 49.02 57.4764H17.9796C16.5916 57.4764 15.2036 56.5931 15.2036 55.2051V19.0544C15.3323 17.6096 16.5292 16.4942 17.9796 16.4677H22.7744V19.6853C22.8411 20.3923 23.4533 20.9211 24.1624 20.8841H42.774C43.4962 20.9236 44.1276 20.402 44.2251 19.6853V16.4676H49.0199C50.4701 16.4942 51.6672 17.6095 51.7959 19.0543V55.2051H51.796Z",
    fill: "url(#paint1_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7486 34.6853H32.2379C31.541 34.6853 30.9761 35.2502 30.9761 35.9471C30.9761 36.644 31.541 37.2089 32.2379 37.2089H46.7486C47.4455 37.2089 48.0104 36.644 48.0104 35.9471C48.0104 35.2502 47.4455 34.6853 46.7486 34.6853Z",
    fill: "url(#paint2_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6483 35.8907L26.6512 44.8936C27.0836 45.326 27.7846 45.326 28.217 44.8936C28.6493 44.4613 28.6493 43.7603 28.217 43.3279L19.214 34.325C18.7816 33.8926 18.0806 33.8926 17.6483 34.325C17.2159 34.7573 17.2159 35.4583 17.6483 35.8907Z",
    fill: "url(#paint3_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6513 34.3253L17.6483 43.3282C17.216 43.7606 17.216 44.4616 17.6483 44.894C18.0807 45.3263 18.7817 45.3263 19.2141 44.894L28.217 35.891C28.6494 35.4586 28.6494 34.7577 28.217 34.3253C27.7846 33.8929 27.0837 33.8929 26.6513 34.3253Z",
    fill: "url(#paint4_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7486 27.824H32.2379C31.541 27.824 30.9761 28.3889 30.9761 29.0858C30.9761 29.7827 31.541 30.3476 32.2379 30.3476H46.7486C47.4455 30.3476 48.0104 29.7827 48.0104 29.0858C48.0104 28.3889 47.4455 27.824 46.7486 27.824Z",
    fill: "url(#paint5_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5038 48.1333H31.993C31.2961 48.1333 30.7312 48.6982 30.7312 49.3951C30.7312 50.092 31.2961 50.6569 31.993 50.6569H46.5038C47.2007 50.6569 47.7656 50.092 47.7656 49.3951C47.7656 48.6982 47.2007 48.1333 46.5038 48.1333Z",
    fill: "url(#paint6_linear_1223_9072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5038 41.0129H31.993C31.2961 41.0129 30.7312 41.5779 30.7312 42.2747C30.7312 42.9716 31.2961 43.5366 31.993 43.5366H46.5038C47.2007 43.5366 47.7656 42.9716 47.7656 42.2747C47.7656 41.5779 47.2007 41.0129 46.5038 41.0129Z",
    fill: "url(#paint7_linear_1223_9072)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1223_9072",
    x1: -2.5332e-7,
    y1: 34,
    x2: 68,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1223_9072",
    x1: 33.4998,
    y1: 59.9999,
    x2: 33.4998,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1223_9072",
    x1: 39.4933,
    y1: 37.2089,
    x2: 39.4933,
    y2: 34.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1223_9072",
    x1: 23.7155,
    y1: 38.8264,
    x2: 22.1497,
    y2: 40.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1223_9072",
    x1: 23.7156,
    y1: 40.3925,
    x2: 22.1498,
    y2: 38.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1223_9072",
    x1: 39.4933,
    y1: 30.3476,
    x2: 39.4933,
    y2: 27.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1223_9072",
    x1: 39.2484,
    y1: 50.6569,
    x2: 39.2484,
    y2: 48.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1223_9072",
    x1: 39.2484,
    y1: 43.5366,
    x2: 39.2484,
    y2: 41.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1223_9072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHistoryIcon);
export default __webpack_public_path__ + "static/media/no-req-history-icon.864f260a2e9cf265656bc4977fe58da6.svg";
export { ForwardRef as ReactComponent };